import React from 'react';
import { Box, Typography } from '@mui/material';
import { brandHome } from '../../brandHomeTokens';
import { SEVERITY_TONES, type Severity } from '../../severityTones';

export interface StoreIssue {
  severity: Extract<Severity, 'blocking' | 'warning'>;
  title: string;
  meta: string;
  age?: string;
}

interface StoreIssuesPanelProps {
  /** Structurally excludes rebate disputes — there is no backend concept for them. */
  issues: StoreIssue[];
}

export const StoreIssuesPanel: React.FC<StoreIssuesPanelProps> = ({ issues }) => {
  if (issues.length === 0) return null;
  const worst = issues.some((i) => i.severity === 'blocking') ? 'blocking' : 'warning';
  const tone = SEVERITY_TONES[worst];

  return (
    <Box sx={{ border: `1px solid ${tone.border}`, bgcolor: tone.bg, borderRadius: `${brandHome.radius.inset}px`, p: '10px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: brandHome.color.muted }}>
        Issues this store has with your brand
      </Typography>
      {issues.map((issue, index) => {
        const dotTone = SEVERITY_TONES[issue.severity];
        return (
          <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: '9px' }}>
            <Box sx={{ width: 7, height: 7, borderRadius: '4px', mt: '5px', flex: '0 0 auto', bgcolor: dotTone.dot }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1px', minWidth: 0 }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{issue.title}</Typography>
              <Typography sx={{ fontSize: '11.5px', color: brandHome.color.muted }}>{issue.meta}</Typography>
            </Box>
            {issue.age && (
              <Typography sx={{ ml: 'auto', fontSize: '11.5px', color: brandHome.color.faint, flex: '0 0 auto' }}>{issue.age}</Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
